/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import '../../hooks/index.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import '../../hooks/icon.mjs';
import 'lodash-es';
import '../../hooks/slot.mjs';
import '../../_chunks/dep-6da93342.mjs';
import '../../utils/render-tnode.mjs';
import '../../_chunks/dep-5112e56c.mjs';
import '../../hooks/useCommonClassName.mjs';
import '../../config-provider/hooks/useConfig.mjs';
import '../../config-provider/utils/context.mjs';
import '../../_chunks/dep-99da72b8.mjs';
import '../../_chunks/dep-b0ea6825.mjs';
import '../../_chunks/dep-2705c570.mjs';
import '../../_chunks/dep-bc824998.mjs';
import '../../config-provider/type.mjs';
import '../../hooks/useDefaultValue.mjs';
import '../../hooks/useDestroyOnClose.mjs';
import '../../hooks/useKeepAnimation.mjs';
import '../../hooks/useRipple.mjs';
import '../../_chunks/dep-b0b0fb5e.mjs';
import '../../hooks/useVirtualScroll.mjs';
import '../../_chunks/dep-6e49aa22.mjs';
import '../../hooks/useVModel.mjs';
import '../../hooks/useImagePreviewUrl.mjs';
import '../../_chunks/dep-8d3c9348.mjs';
import '../../_chunks/dep-d531a7f4.mjs';
import '../../_chunks/dep-46061e10.mjs';
import '../../_chunks/dep-1def7a80.mjs';

var FORM_CONTROL_COMPONENTS = ["TInput", "TInputNumber", "TTextarea", "TCascader", "TSelect", "TOption", "TSwitch", "TCheckbox", "TCheckboxGroup", "TRadio", "TRadioGroup", "TTreeSelect", "TDatePicker", "TTimePicker", "TUpload", "TTransfer", "TSlider"];
var useCLASSNAMES = function useCLASSNAMES() {
  var classPrefix = usePrefixClass();
  return computed(function () {
    var form = "".concat(classPrefix.value, "-form");
    var input = "".concat(classPrefix.value, "-input");
    var is = "".concat(classPrefix.value, "-is");
    return {
      form: form,
      label: "".concat(form, "__label"),
      labelTop: "".concat(form, "__label--top"),
      inline: "".concat(form, "-inline"),
      formItem: "".concat(form, "__item"),
      formItemWithHelp: "".concat(form, "__item-with-help"),
      formItemWithExtra: "".concat(form, "__item-with-extra"),
      controls: "".concat(form, "__controls"),
      controlsContent: "".concat(form, "__controls-content"),
      status: "".concat(form, "__status"),
      extra: "".concat(input, "__extra"),
      help: "".concat(input, "__help"),
      success: "".concat(is, "-success"),
      successBorder: "".concat(form, "--success-border"),
      error: "".concat(is, "-error"),
      warning: "".concat(is, "-warning")
    };
  });
};
var ValidateStatus = /* @__PURE__ */function (ValidateStatus2) {
  ValidateStatus2["TO_BE_VALIDATED"] = "not";
  ValidateStatus2["SUCCESS"] = "success";
  ValidateStatus2["FAIL"] = "fail";
  return ValidateStatus2;
}(ValidateStatus || {});
var FormInjectionKey = Symbol("FormProvide");
var FormItemInjectionKey = Symbol("FormItemProvide");

export { FORM_CONTROL_COMPONENTS, FormInjectionKey, FormItemInjectionKey, ValidateStatus, useCLASSNAMES };
//# sourceMappingURL=index.mjs.map
